// extracted by mini-css-extract-plugin
export default {"postModalOverlay":"Modal_postModalOverlay__rWyHf","postModalContent":"Modal_postModalContent__a69yL"};